import React from 'react';
import { useParams } from 'react-router-dom';
import Gallery from '../components/Gallery';
import { locations } from '../data/locations';

// ✅ Utility function for proper case
const toProperCase = (str: string) =>
  str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());

const Location: React.FC = () => {
  const { name } = useParams<{ name: string }>();
  const location = locations.find((l) => l.slug === name?.toLowerCase());

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #faf5ff 100%)',
        minHeight: '100vh',
      }}
    >
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '32px 20px 12px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '10px' }}>
          <h2
            style={{
              margin: 0,
              fontSize: 'clamp(22px, 3.5vw, 28px)',
              fontWeight: 800,
              letterSpacing: '-0.5px',
              color: '#171616',
            }}
          >
            {location?.name || (name ? toProperCase(name) : '')}
          </h2>
          {location && (
            <span
              style={{
                fontSize: 'clamp(16px, 2.5vw, 20px)',
                fontWeight: 500,
                color: '#64748b',
              }}
            >
              {location.country}
            </span>
          )}
        </div>
        {location && (
          <span
            style={{
              display: 'inline-block',
              marginTop: '10px',
              padding: '5px 14px',
              borderRadius: '999px',
              background: 'rgba(99,102,241,0.1)',
              color: '#6366f1',
              fontSize: '13px',
              fontWeight: 600,
            }}
          >
            {location.dateRange}
          </span>
        )}
      </div>

      {/* Gallery */}
      <Gallery location={name || ''} />
    </div>
  );
};

export default Location;
